<template>
	<aside class="col-span-12 tabletWide:col-span-4 desktop:col-span-3 tabletWide:sticky tabletWide:top-[7.6rem] border border-goGrayBrighter rounded-6 py-24 mb-32 tablet:mb-0 space-y-16">
		<h2 class="font-bold px-24">Trip itinerary</h2>
		<ul>
			<li v-for="item in contents" :key="item.id">
				<button class="link font-bold text-14 text-left link-goBlue py-4 px-24 w-full" :class="{'tabletWide:bg-goPinkBrighter tabletWide:text-goPink': item.id === activeItineraryId}" @click.prevent="handleItineraryButtonClick(item.id)">{{ item.title }}</button>
			</li>
		</ul>
		<div class="px-24">
			<button class="button button-goPink button-small" @click.prevent="$scrollTo('booking-widget')">Book a vehicle</button>
		</div>
	</aside>
</template>

<script>
import debounce from "lodash/debounce"

export default {
	props: {
		contents: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			activeItineraryId: null,
			itinerarySections: [],
			debouncedHandleScroll: null,
		}
	},
	computed: {
		isTabletWide() {
			return this.$store.state.browser.breakpoint.isTabletWide
		},
	},
	watch: {
		isTabletWide(newValue) {
			if (newValue) {
				this.debouncedHandleScroll
					? window.addEventListener("scroll", this.debouncedHandleScroll)
					: this.initScrollSections()
			} else {
				window.removeEventListener("scroll", this.debouncedHandleScroll)
			}
		},
	},
	mounted() {
		if (this.isTabletWide) this.initScrollSections()
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.debouncedHandleScroll)
	},
	methods: {
		initScrollSections() {
			this.itinerarySections = Array.from(document.querySelectorAll("[id^='itinerary-']"))
			this.activeItineraryId = this.itinerarySections[0]?.id ?? null
			this.debouncedHandleScroll = debounce(this.handleScroll, 50)
			window.addEventListener("scroll", this.debouncedHandleScroll)
		},
		handleScroll() {
			const halfWindowHeight = window.innerHeight / 2
			for (const section of this.itinerarySections) {
				const sectionRect = section.getBoundingClientRect()
				if (this.activeItineraryId !== section.id && sectionRect.top <= halfWindowHeight && sectionRect.bottom >= halfWindowHeight) {
					this.activeItineraryId = section.id
					break
				}
			}
		},
		handleItineraryButtonClick(id) {
			this.$scrollTo(id)
			this.activeItineraryId = id
		},
 	},
}
</script>
